import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class VehicleService {
  constructor(private http: HttpClientService) {}

  public updateVehicle(vehicle_id, vehicleParams): Observable<any> {
    return this.http
      .put("/api/vehicles/" + vehicle_id, vehicleParams)
      .pipe(tap((_) => console.log("VehicleService.updateVehicle: Ok.")));
  }

  public accidentInfo(id): Observable<any> {
    return this.http
      .post("/api/vehicles/" + id + "/closure_info/", null)
      .pipe(tap((_) => console.log("VehicleService.accidentInfo: Ok.")));
  }

  public loadInfo(content, file_type): Observable<any> {
    return this.http
      .post("/api/vehicles/load_info", { content, file_type })
      .pipe(tap((_) => console.log("GpsService.loadInfo: Ok.")));
  }
}
